// Dependencies
import React from 'react';

import PropTypes from 'prop-types';

// Local Components
import Cta from '../cta/cta';

// CSS
require('./card-cta.less');

const CardCta = ({ children, ...otherProps }) => (
  <div className="card-cta">
    <Cta {...otherProps}>{children}</Cta>
  </div>
);

CardCta.propTypes = {
  children: PropTypes.node.isRequired,
  iconName: PropTypes.string.isRequired,
  trackingId: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

CardCta.defaultProps = {
  subtitle: null,
};

export default CardCta;
